import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getProductCompletionSheetDetailFetchSuccess,
    getProductCompletionSheetDetailFetchFailure,
    createProductCompletionSheetDetailFetchSuccess,
    createProductCompletionSheetDetailFetchFailure,
    updateProductCompletionSheetDetailFetchSuccess,
    updateProductCompletionSheetDetailFetchFailure,
} from './reducer';
import { getProductCompletionSheetsListFetch } from 'src/resources/productCompletionSheetsList/reducer';
import { ProductCompletionSheetDetailResType } from 'src/types/productCompletionSheetDetail';
import { ProductCompletionSheetType } from 'src/types/productCompletionSheet';
import translate from '@translate';

const getProductCompletionSheetDetailFetchRequest = async (idProductCompletionSheet: string) => {
    const res = await api('get', `api/secure/product-completion-sheets/${idProductCompletionSheet}`);
    return res.data.data;
};

function* getProductCompletionSheetDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ProductCompletionSheetDetailResType = yield call((): any =>
            getProductCompletionSheetDetailFetchRequest(action.payload)
        );
        yield put(getProductCompletionSheetDetailFetchSuccess(response));
    } catch (error) {
        yield put(getProductCompletionSheetDetailFetchFailure({ error }));
    }
}

export function* getProductCompletionSheetDetailFetchWatch() {
    yield takeEvery(
        'productCompletionSheetDetail/getProductCompletionSheetDetailFetch',
        getProductCompletionSheetDetailFetch
    );
}

const createProductCompletionSheetDetailFetchRequest = async (data: ProductCompletionSheetType) => {
    const res = await api('post', 'api/secure/product-completion-sheets', data);
    return res.data.data;
};

function* createProductCompletionSheetDetailFetch(action: { type: string; payload: ProductCompletionSheetType }) {
    try {
        const response: ProductCompletionSheetDetailResType = yield call((): any =>
            createProductCompletionSheetDetailFetchRequest(action.payload)
        );
        yield put(
            createProductCompletionSheetDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('productCompletionSheets.message.productCompletionSheetCreated') },
            })
        );
        yield put(getProductCompletionSheetsListFetch());
    } catch (error) {
        yield put(createProductCompletionSheetDetailFetchFailure({ error }));
    }
}

export function* createProductCompletionSheetDetailFetchWatch() {
    yield takeEvery(
        'productCompletionSheetDetail/createProductCompletionSheetDetailFetch',
        createProductCompletionSheetDetailFetch
    );
}

const updateProductCompletionSheetDetailFetchRequest = async (params: {
    idProductCompletionSheet: string;
    data: ProductCompletionSheetType;
}) => {
    const res = await api(
        'put',
        `api/secure/product-completion-sheets/${params.idProductCompletionSheet}`,
        params.data
    );
    return res.data.data;
};

function* updateProductCompletionSheetDetailFetch(action: {
    type: string;
    payload: { idProductCompletionSheet: string; data: ProductCompletionSheetType };
}) {
    try {
        const response: ProductCompletionSheetDetailResType = yield call((): any =>
            updateProductCompletionSheetDetailFetchRequest(action.payload)
        );
        yield put(
            updateProductCompletionSheetDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('productCompletionSheets.message.productCompletionSheetUpdate') },
            })
        );
        yield put(getProductCompletionSheetsListFetch());
    } catch (error) {
        yield put(updateProductCompletionSheetDetailFetchFailure({ error }));
    }
}

export function* updateProductCompletionSheetDetailFetchWatch() {
    yield takeEvery(
        'productCompletionSheetDetail/updateProductCompletionSheetDetailFetch',
        updateProductCompletionSheetDetailFetch
    );
}
